import axiosInstance from './axiosInstance';
import { extractErrorMessage } from '../utils/errorHandler';
import { API_BASE_URL } from './api';

export const googleDriveService = {
  async checkShipmentCmr(shipmentNumber) {
    try {
      const response = await axiosInstance.get(`${API_BASE_URL}shipments/${shipmentNumber}/cmr/`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Error checking CMR:', error);
      return {
        success: false,
        error: extractErrorMessage(error),
      };
    }
  },

  async getCmrFileLink(fileId) {
    try {
      const response = await axiosInstance.get(`${API_BASE_URL}cmr/file/${fileId}/`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Error getting CMR link:', error);
      return {
        success: false,
        error: extractErrorMessage(error),
      };
    }
  },
};
